import React from 'react'
import {Link} from 'react-router-dom'
import moment from 'moment'
import {removeAction} from '../utils/helpers'
import {shouldDisplayFonctionnalite} from '../../../../components/helpers'

const TableView = (props) => {
  const {actions, currentUser, setActions} = props

  return (
    <div className='card-body py-3'>
      <div className='table-responsive'>
        {/* begin::Table */}
        <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
          {/* begin::Table head */}
          <thead>
            <tr className='fw-bold text-muted'>
              <th>Id</th>
              <th className='min-w-140px'>Titre</th>
              <th className='min-w-140px'>Type</th>
              <th className='min-w-140px'>Statut</th>
              <th className='min-w-140px'>Origine</th>
              <th className='min-w-140px'>Echéance</th>
              <th className='min-w-140px'>Assigné</th>
              <th className='min-w-140px'>Client</th>
              <th className='min-w-140px'>Demande</th>
              <th className='min-w-140px'>Prioritaire</th>
              <th className='min-w-100px text-end'>Actions</th>
            </tr>
          </thead>
          {/* end::Table head */}
          {/* begin::Table body */}
          <tbody>
            {actions.length ? (
              actions.map((action) => {
                return (
                  <tr key={action.id}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>{action?.id}</div>
                      </div>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.titre}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.type?.libelle}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.statut?.libelle}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.origine}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.dateEcheance
                          ? moment.parseZone(action.dateEcheance).format('DD/MM/YYYY HH:mm:ss')
                          : ''}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.assigneeA
                          ? action.assigneeA.prenom === currentUser.prenom &&
                            action.assigneeA.nom === currentUser.nom
                            ? 'Moi'
                            : `${action.assigneeA.prenom} ${action.assigneeA.nom}`
                          : ''}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.client?.prenom} {action?.client?.nom}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.demande?.id ?? action?.savDossier?.numero}
                      </p>
                    </td>
                    <td>
                      <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'>
                        {action?.prioritaire ? 'Oui' : 'Non'}
                      </p>
                    </td>
                    <td>
                      {((shouldDisplayFonctionnalite(currentUser, 'MODIFIER ACTION') ||
                        shouldDisplayFonctionnalite(currentUser, 'SUPPRIMER ACTION')) &&
                        action?.statut?.code === 'NOUVELLE' ||
                        action?.statut?.code === 'NONLUE' ||
                        action?.statut?.code === 'LU') &&
                        (
                          <div className='d-flex justify-content-end flex-shrink-0'>
                            {shouldDisplayFonctionnalite(currentUser, 'MODIFIER ACTION') && (
                              <Link
                                to={`/mes-actions/${action.id}/modifier`}
                                state={{view: props?.view, filters: props?.filters}}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                              >
                                <i className='bi bi-pencil-square fs-2'></i>
                              </Link>
                            )}
                            {shouldDisplayFonctionnalite(currentUser, 'SUPPRIMER ACTION') && (
                              <p
                                onClick={() => {
                                  removeAction(action.id, setActions)
                                }}
                                className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 my-0'
                              >
                                <i className='bi bi-trash fs-2'></i>
                              </p>
                            )}
                          </div>
                        )}
                    </td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td colSpan={11} className='text-center'>
                  Aucun résultat trouvé
                </td>
              </tr>
            )}
          </tbody>
          {/* end::Table body */}
        </table>
        {/* end::Table */}
      </div>
    </div>
  )
}

export {TableView}
